module.exports = __webpack_public_path__ + "static/img/banner2@2x.7a65546.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopIntr/shop/banner2@2x.png
// module id = BHUc
// module chunks = 18